import React from 'react';
import {useEffect} from "react";
import useGeolocation from "react-hook-geolocation";

function GeolocationProbe({setGeolocationCallback, setGeolocationResult}) {

		const geolocation = useGeolocation({
				enableHighAccuracy: true,
				timeout:            12000
		});

		useEffect(() => {
				return () => {
						console.log("Geolocation updated:", geolocation)
						if (geolocation.longitude!==null && geolocation.latitude!==null) {
								console.log("Geolocation updated: Calling geoloc callback:", geolocation);
								setGeolocationResult("success");
								setGeolocationCallback(geolocation);
						} else {
								console.log("Geolocation updated: Geolocation error:", geolocation);
								setGeolocationResult("error");
						}
				};
		}, [geolocation]);


		return (<div className="c-locator__probe"></div>)
}

export default GeolocationProbe;
